import { isLoading, loading } from "../Loading";
import { AppState } from "../system/AppState";
import useMixin from "./useMixin";

const useAgencies = (appState: AppState) => {
  const { appAgenciesState } = useMixin(appState);

  if (isLoading(appAgenciesState)) {
    return loading();
  }

  return appAgenciesState.agencies;
};

export default useAgencies;
